__turbopack_context__.v({
  "switch": "Switch-module-scss-module__Y3pFMW__switch",
  "switchThumb": "Switch-module-scss-module__Y3pFMW__switchThumb",
});
